// eslint-disable-next-line max-classes-per-file
import { deserialize } from 'cerialize'

const hasLocalStorage = !!(window && window.localStorage)

export const SESSION_LS_NAME = 'pp.admin.session'

class SettingsLS {
	@deserialize public showStartPageAnimation?: boolean
	@deserialize public redirect?: string
	@deserialize public partnerPaymentModalVisible?: boolean
	@deserialize public viewedServiceNotifications?: number[]
	@deserialize public isPotentialPartner?: boolean
	@deserialize public showTop150Tooltip?: boolean
}
class ClassLocalStorage {
	private getFromLS = (key: string): any => {
		try {
			if (hasLocalStorage) {
				return JSON.parse(window.localStorage.getItem(key))
			}
		} catch (e) {
			// eslint-disable-next-line no-console
			console.warn(`LocalStorage: get item error`, e)
		}
	}
	private setToLS = (key: string, data: any): any => {
		try {
			if (hasLocalStorage) {
				window.localStorage.setItem(key, JSON.stringify(data))
			}
		} catch (e) {
			// eslint-disable-next-line no-console
			console.warn(`LocalStorage: set item error`, e)
		}
	}

	private getStorage = (): any => this.getFromLS(SESSION_LS_NAME) || {}
	private setStorage = (data: any): any => this.setToLS(SESSION_LS_NAME, data)

	public setAuth = (auth: any): any => {
		const storage = this.getStorage()
		storage.auth = { ...storage.auth, ...auth }
		this.setStorage(storage)
	}
	public removeAuth = (): any => {
		// eslint-disable-next-line
		const { auth, substitution, ...storage } = this.getStorage()
		return this.setStorage(storage)
	}

	public getUserSettings = (): any => this.getStorage().settings || {}
	public getUserAuth = (): any => this.getStorage().auth
	public setUserSettings = (settings: SettingsLS): any => {
		const storage = this.getStorage()
		storage.settings = { ...storage.settings, ...settings }
		this.setStorage(storage)
	}
	public getItem = (item: string): any => this.getStorage()[item] || {}
	public setSubstitution = (substitution: any): any => {
		const storage = this.getStorage()
		storage.substitution = { ...storage.substitution, ...substitution }
		this.setStorage(storage)
	}
	public getSubstitution = (): any => this.getStorage().substitution
	public getSessionId = (): any => this.getSubstitution()?.id
	public removeSubstitution = (): any => {
		// eslint-disable-next-line
		const { substitution, ...storage } = this.getStorage()
		return this.setStorage(storage)
	}
}

export const LocalStorage = new ClassLocalStorage()
